import RefereeForm from "@/components/onboarding/referee-form";
import { trpc } from "@/trpc/react";
import React from "react";
import { ActivityIndicator, View } from "react-native";
import { KeyboardAwareScrollView, KeyboardToolbar } from "react-native-keyboard-controller";

export default function RefereeCvPage() {
  const { data: recruitmentData, isLoading, refetch } = trpc.recruitment.getById.useQuery();

  if (isLoading || !recruitmentData) {
    return (
      <View className="flex-1 justify-center">
        <ActivityIndicator />
      </View>
    );
  }

  return (
    <>
      <KeyboardAwareScrollView
        bottomOffset={62}
        className="flex-1 bg-background p-4"
        contentContainerStyle={{
          gap: 20,
        }}
      >
        <RefereeForm recruitmentData={recruitmentData} onFormSuccess={() => refetch()} />
      </KeyboardAwareScrollView>
      <KeyboardToolbar />
    </>
  );
}